
export const SET_INITIATIVES_GEO_JSON = "MAP:SET_INITIATIVES_GEO_JSON";
export const SET_HUMAN_RESOURCES_GEO_JSON = "MAP:SET_HUMAN_RESOURCES_GEO_JSON";
export const SET_ACTIVE_MAP_SIDE_MENU_ITEM = "MAP:SET_ACTIVE_MAP_SIDE_MENU_ITEM";

export const SET_SHOW_FEATURE_DETAILS = "MAP:SET_SHOW_FEATURE_DETAILS";

export const SET_PROJECTS_SPATIAL_DATA = 'MAP:SET_PROJECTS_SPATIAL_DATA';



// getting projects overview per regions
export const GET_PROJECTS_OVERVIEW_START = "MAP:GET_PROJECTS_OVERVIEW_START";
export const GET_PROJECTS_OVERVIEW_SUCCESS = "MAP:GET_PROJECTS_OVERVIEW_SUCCESS";
export const GET_PROJECTS_OVERVIEW_FAILURE = "MAP:GET_PROJECTS_OVERVIEW_FAILURE";
export const CLEAR_PROJECTS_OVERVIEW = "MAP:CLEAR_PROJECTS_OVERVIEW";

// map loader
export const SHOW_MAP_LOADER = 'MAP:SHOW_MAP_LOADER';


// getting projects based on a region
export const GET_PROJECTS_BY_REGION_START = "MAP:GET_PROJECTS_BY_REGION_START";
export const GET_PROJECTS_BY_REGION_SUCCESS = "MAP:GET_PROJECTS_BY_REGION_SUCCESS";
export const GET_PROJECTS_BY_REGION_FAILURE = "MAP:GET_PROJECTS_BY_REGION_FAILURE";
export const CLEAR_REGION_PROJECTS = "MAP:CLEAR_REGION_PROJECTS";


// getting region details
export const GET_REGION_START = "MAP:GET_REGION_START";
export const GET_REGION_SUCCESS = "MAP:GET_REGION_SUCCESS";
export const GET_REGION_FAILURE = "MAP:GET_REGION_FAILURE";
export const CLEAR_REGION_DETAILS = "MAP:CLEAR_REGION_DETAILS";

export const GET_REGION_PROJECT_STATISTICS_START = "MAP:GET_REGION_PROJECT_STATISTICS_START";
export const GET_REGION_PROJECT_STATISTICS_SUCCESS = "MAP:GET_REGION_PROJECT_STATISTICS_SUCCESS";
export const GET_REGION_PROJECT_STATISTICS_FAILURE = "MAP:GET_REGION_PROJECT_STATISTICS_FAILURE";
export const CLEAR_REGION_PROJECTS_STATISTICS = "MAP:CLEAR_REGION_PROJECTS_STATISTICS";

export const GET_PROJECT_STATISTICS_START = "MAP:GET_PROJECT_STATISTICS_START";
export const GET_PROJECT_STATISTICS_SUCCESS = "MAP:GET_PROJECT_STATISTICS_SUCCESS";
export const GET_PROJECT_STATISTICS_FAILURE = "MAP:GET_PROJECT_STATISTICS_FAILURE";

export const GET_PROJECTS_STATISTICS_START = "MAP:GET_PROJECTS_STATISTICS_START";
export const GET_PROJECTS_STATISTICS_SUCCESS = "MAP:GET_PROJECTS_STATISTICS_SUCCESS";
export const GET_PROJECTS_STATISTICS_FAILURE = "MAP:GET_PROJECTS_STATISTICS_FAILURE";
export const CLEAR_PROJECTS_STATISTICS = "MAP:CLEAR_PROJECTS_STATISTICS";

// SIDE NAV MENU
export const SHOW_NATIONAL_PROJECTS_OVERVIEW = 'MAP:SHOW_NATIONAL_PROJECTS_OVERVIEW';
export const SHOW_REGIONAL_PROJECTS_OVERVIEW = 'MAP:SHOW_REGIONAL_PROJECTS_OVERVIEW';
export const SHOW_PROJECTS_OVERVIEW = 'MAP:SHOW_PROJECTS_OVERVIEW';
export const SHOW_PROJECT_DETAILS = 'MAP:SHOW_PROJECT_DETAILS';
export const SHOW_SUB_PROJECT_DETAILS = 'MAP:SHOW_SUB_PROJECT_DETAILS';
export const SHOW_SUB_PROJECT_ELEMENT_DETAILS = 'MAP:SHOW_SUB_PROJECT_ELEMENT_DETAILS';
export const BACK_SUB_PROJECTS_TO_PROJECTS = 'MAP:BACK_SUB_PROJECTS_TO_PROJECTS';
export const BACK_SUB_PROJECT_ELEMENT_TO_SUB_PROJECT_DETAILS = 'MAP:BACK_SUB_PROJECT_ELEMENT_TO_SUB_PROJECT_DETAILS';


// getting wfs layer data
export const GET_WFS_LAYER_DATA_START = "MAP:GET_WFS_LAYER_DATA_START";
export const GET_WFS_LAYER_DATA_SUCCESS = "MAP:GET_WFS_LAYER_DATA_SUCCESS";
export const GET_WFS_LAYER_DATA_FAILURE = "MAP:GET_WFS_LAYER_DATA_FAILURE";
export const CLEAR_WFS_LAYER_DATA = "MAP:CLEAR_WFS_LAYER_DATA";
